import { LocationType } from 'types/LocationType';
import { UserSearch } from 'types/UserSearch';

export const setBranchLocation = (location: LocationType) => {
  localStorage.setItem('kioskLocation', JSON.stringify(location));
};

export const getBranchLocation = (): LocationType | null => {
  const stored = localStorage.getItem('kioskLocation');
  return stored ? (JSON.parse(stored) as LocationType) : null;
};

export const setUserSearch = (userSearch: UserSearch) => {
  localStorage.setItem('userSearch', JSON.stringify(userSearch));
};

export const storeChargeCodes = (chargeCodes: string[]) => {
  localStorage.setItem('chargeCodes', JSON.stringify(chargeCodes));
};

export const getChargeCodes = (): string[] => {
  const userSearchString = localStorage.getItem('chargeCodes');

  if (userSearchString) {
    return JSON.parse(userSearchString) as string[];
  }
  return [];
};

export const getUserSearch = (): UserSearch | null => {
  const userSearchString = localStorage.getItem('userSearch');

  if (userSearchString) {
    return JSON.parse(userSearchString) as UserSearch;
  }

  return null;
};

export const storeAllLocalBranches = (allBranches: LocationType[]) => {
  localStorage.setItem('allBranches', JSON.stringify(allBranches));
};

export const getAllLocalBranches = (): LocationType[] => {
  const allBranches = localStorage.getItem('allBranches');

  if (allBranches) {
    return JSON.parse(allBranches) as LocationType[];
  }
  return [];
};

export const setBranchLocationCode = (locationCode: string) => {
  localStorage.setItem('locationCode', locationCode);
};
export const getBranchLocationCode = (): string => {
  const locationCode = localStorage.getItem('locationCode');
  return locationCode;
};
